let confirmHandler = null;

function normalizeOptions(options) {
  if (typeof options === "string") {
    return {
      title: "Please confirm",
      message: options,
      confirmLabel: "Confirm",
      cancelLabel: "Cancel",
      tone: "danger",
    };
  }

  const nextOptions = options || {};
  return {
    title: nextOptions.title || "Please confirm",
    message: nextOptions.message || "",
    confirmLabel: nextOptions.confirmLabel || "Confirm",
    cancelLabel: nextOptions.cancelLabel || "Cancel",
    tone: nextOptions.tone || "danger",
    // Optional stable data-testid for the rendered dialog, so a caller that
    // needs to be automation-driveable (per AGENTS.md's Automation-First UI
    // Contract) can target this specific confirmation. Omitted by existing
    // callers — ConfirmDialogHost simply renders no attribute in that case.
    testId: nextOptions.testId || undefined,
  };
}

export function registerConfirmDialog(handler) {
  confirmHandler = handler;

  return () => {
    if (confirmHandler === handler) {
      confirmHandler = null;
    }
  };
}

export function confirmDialog(options) {
  const normalized = normalizeOptions(options);

  if (typeof confirmHandler === "function") {
    return confirmHandler(normalized);
  }

  if (typeof window !== "undefined" && typeof window.confirm === "function") {
    return Promise.resolve(window.confirm(normalized.message || normalized.title));
  }

  return Promise.resolve(false);
}

